function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M45.387 99.836c-9.473-.941-18.004-4.242-25.48-9.867C8.579 81.445 1.54 68.797.169 54.485c-.32-3.352-.18-8.297.332-11.812C2.981 25.755 14.122 11.146 29.825 4.22c3.95-1.742 8.61-3.086 12.832-3.707 4.594-.672 10.086-.672 14.676 0 16.918 2.48 31.527 13.62 38.453 29.324 1.742 3.949 3.086 8.61 3.707 12.832.672 4.594.672 10.086 0 14.676-1.906 13.008-9.02 24.902-19.617 32.789-7.441 5.539-15.973 8.797-25.406 9.703-2.074.2-7.07.195-9.086-.004zm23.805-45.137V39.652l-9.164-9.164H55.09v10.734H36.332V30.488h-5.53v39.258h38.39zm-32.965 3.336v-7.266h27.547V65.3H36.227zm25.156 3.09v-1.79H38.61v3.579h22.773zm0-5.856V53.48H38.61v3.578h22.773zM49.996 34.394v-3.902h-5.422v7.805h5.422z"
});

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.ed3a604a.svg";
export { ForwardRef as ReactComponent };